import type { IBrandConfig } from './types';

const PCPROTECT_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: { kind: 'legalPolicy', type: 'privacy' },
  termsOfService: { kind: 'legalPolicy', type: 'servicing' },
  websiteTermsOfUse: { kind: 'legalPolicy', type: 'terms' },
  /* Angular hides the refund link for this brand, so there is no refund document. */
  refundPolicy: { kind: 'none' },
  idTheftProtection: { kind: 'none' },
  licensor: 'intersections',
  defaultBillingCategoryKey: 'identitydefense_d2c',
  copyRightEntity: 'Intersections LLC dba Pango',
  hasCustomerServiceSupport: true,
  ssoRedirectURL: 'https://my.pcprotect.com/identity-protection',
  carouselBanners: false,
  unlockInsurance: { fromPlanCode: 'drkwebfam', toPlanCode: 'basicfam' },
  security: false,
  plan: true,
  finishSetup: false,
  adaChat: false,
  vaultProject: 'identityguard_watson',
  secureUpload: true,
  accountDetails: true,
  dwEmailVerification: {
    adaChat: false,
    signInButton: true,
    supportAt: null,
    availability:
      'Representatives are available Monday – Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      availability: (
        <>
          Monday – Friday, 8AM-11PM ET <br /> Saturday, 9AM-6PM ET
        </>
      ),
    },
    mail: {
      active: true,
      address: 'PO Box 52330 Boston, MA 02205',
      customerSupport: false,
    },
    email: {
      active: true,
      customerSupport: true,
    },
  },
};

export default PCPROTECT_BRAND_CONFIG;
